import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchStores } from 'utils/api/storeApi'
import { useQuery } from 'hooks'
import { DataTable, DataTablePagination } from 'components/common'
import { getColumns } from './utils'
import useModal from 'hooks/useModal'
import ConfirmDeleteStoreModal from './confirmDeleteStoreModal'
import { ICellRendererParams } from '@ag-grid-community/core'

type StoreTableProps = {
  isEditor: boolean
}

const StoreTable = ({ isEditor }: StoreTableProps) => {
  const [storesData, setStoresData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  // preserve the selected store params while open modal for deletion
  const [gridParams, setGridParams] = useState<ICellRendererParams>()

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const { closeModal, isOpen, openModal } = useModal()

  const getStores = async () => {
    setLoading(true)
    const { limit, search: SearchTerm, page } = getAllQueries()
    try {
      const { data } = await fetchStores({
        limit: limit || 10,
        page: page || 1,
        search: SearchTerm,
      })
      setStoresData({ ...data })
    } catch (error) {
      setStoresData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStores()
  }, [search])

  const getStoreToDelete = (params: ICellRendererParams) => {
    if (!isEditor) return
    setGridParams(params)
    openModal()
  }

  const columns = useMemo(
    () => getColumns(isEditor, getStoreToDelete),
    [isEditor],
  )

  return (
    <>
      <DataTable
        columns={columns}
        rows={loading ? null : storesData?.docs}
        identifier="_id"
      />

      {/* Confirm Delete Modal */}
      {isEditor && (
        <ConfirmDeleteStoreModal
          params={gridParams}
          closeModal={closeModal}
          isOpen={isOpen}
        />
      )}

      {/* Pagination */}
      <DataTablePagination
        currentPage={storesData?.page}
        totalPages={storesData?.totalPages}
        hasNextPage={storesData?.hasNextPage}
        hasPrevPage={storesData?.hasPrevPage}
        limit={storesData?.limit}
        nextPage={storesData?.nextPage}
        prevPage={storesData?.prevPage}
      />
    </>
  )
}

export default StoreTable
